import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import React, { useState, useRef, useEffect } from 'react'
import { useTimer } from "./hooks/useTimer";
import Options from './Options';
import Sound from './audio/Start-bell.wav';
import Bell from './audio/EndBell.m4a';
import {Container, Button} from 'react-bootstrap';
import { BsPlayCircle, BsPauseCircle, BsStopCircle } from "react-icons/bs";


const endBell = new Audio(Bell);
const startBell = new Audio(Sound);

// // // https://blog.avneesh.tech/how-to-make-a-count-down-timer-in-react#heading-creating-the-countdown-timer



// export default function Clock() {
// //   const getTimeLeft = () => {
// //     const difference = +new Date() - +new Date();
// //     let timeLeft = {};
// //     if (difference > 0) {
// //       timeLeft = {
// //         hours: Math.floor(difference / (1000 * 60 * 60)),
// //         minutes: Math.floor((difference / 1000 / 60) % 60),
// //         seconds: Math.floor((difference / 1000) % 60),
// //       };
// //     }
// //     return timeLeft;
  
// //     const [timeLeft, setTimeLeft] = useState(getTimeLeft());
    
// //     useEffect(() => {
// //       setTimeout(() => {
// //         setTimeLeft(getTimeLeft());
// //       }, 1000);
// //     });
  
// //   }
// //   return (
// //     <div>Clock</div>
// //   )
// // }


// // import { useEffect, useState } from "react";

// // const originalTime = Date.now();
// // const setTime = originalTime + 300

// // function Clock() {
  
// //   const calculateTimeLeft = () => {
// //     var difference = Date.now() - setTime
    
    
  
    
// //     let timeLeft = {};

// //     if (difference > 0) {
// //       timeLeft = {
// //         hours: Math.floor(difference / (1000 * 60 * 60)),
// //         minutes: Math.floor((difference / 1000 / 60) % 60),
// //         seconds: Math.floor((difference / 1000) % 60),
// //       };
// //     }

// //     return timeLeft;
// //   };

// //   const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

// //   useEffect(() => {
// //     setTimeout(() => {
// //       setTimeLeft(calculateTimeLeft());
// //     }, 1000);
// //   });

// // Select Every Count Container
// const countContainer = document.querySelectorAll(".count-digit");

// // Select option buttons
// const startAction = document.getElementById("start-timer");
// const stopAction = document.getElementById("stop-timer");
// const resetAction = document.getElementById("reset-timer");

// // Select HTML5 Audio element
// const timeoutAudio = document.getElementById("alarm_audio");

// // Default inital value of timer
// const defaultValue = 30 * 60;

// // variable to the time
// var countDownTime = defaultValue;

// // variable to store time interval
// var timerID;

// // Variable to track whether timer is running or not
// var isStopped = true;

// var minutes;

// var seconds;

// // Function calculate time string
// const findTimeString = () => {
//   var minutes = String(Math.floor(countDownTime / 60));
//   var seconds = String(countDownTime % 60);
//   if (minutes.length === 1) {
//     minutes = "0" + minutes;
//   }
//   if (seconds.length === 1) {
//     seconds = "0" + seconds;
//   }
//   return minutes + seconds;
// };

// // Function to start Countdown
// const startTimer = () => {
//   if (isStopped) {
//     isStopped = false;
//     timerID = setInterval(runCountDown, 1000);
//   }
// };

// // Function to stop Countdown
// const stopTimer = () => {
//   isStopped = true;
//   if (timerID) {
//     clearInterval(timerID);
//   }
// };

// // Function to reset Countdown
// const resetTimer = () => {
//   stopTimer();
//   countDownTime = defaultValue;
// };

// // Initialize alarm sound
// // timeoutAudio.src = "http://soundbible.com/grab.php?id=1252&type=mp3";
// // timeoutAudio.load();



// // function to execute timer
// const runCountDown = () => {
//   // decement time
//   countDownTime -= 1;

//   // timeout on zero
//   if (countDownTime === 0) {
//     stopTimer();
//     // Play alarm on timeout
//     timeoutAudio.play();
//     countDownTime = defaultValue;
//   }
// };

//   return (
//     <div className="Clock">
//       {minutes || seconds ? (
//         <p>
//           <span></span>
//           <span>:</span>
//           <span>{minutes}</span>
//           <span>:</span>
//           <span>{seconds}</span>
//         </p>
//       ) : (
//         <p>Time is up 🔥</p>
// //       )}
// //       <div className="optons">
// //         <button id="stop-timer" onClick={stopTimer}>Stop</button>
// //         <button id="start-timer" onClick={startTimer}>Start</button>
// //         <button id="reset-timer" onClick={resetTimer}>Reset</button>
// //       </div>
// //     </div>
// //   );
// // }

// // // export default Clock;

// import React, { useState, useRef, useEffect } from 'react'
  


//     // We need ref in this, because we are dealing
//     // with JS setInterval to keep track of it and
//     // stop it when needed
//     const Ref = useRef(null);

//     // The state for our timer
//     const [timer, setTimer] = useState('00:00:00');
  
  
//     const getTimeRemaining = (e) => {
//         const total = Date.parse(e) - Date.parse(new Date());
//         const seconds = Math.floor((total / 1000) % 60);
//         const minutes = Math.floor((total / 1000 / 60) % 60);
//         const hours = Math.floor((total / 1000 / 60 / 60) % 24);
//         return {
  //             total, hours, minutes, seconds
  //         };
//     }

  
//     const startTimer = (e) => {
//         let { total, hours, minutes, seconds } 
//                     = getTimeRemaining(e);
//         if (total >= 0) {
  
  //             // update the timer
  //             // check if less than 10 then we need to 
  //             // add '0' at the beginning of the variable
  //             setTimer(
    //                 (hours > 9 ? hours : '0' + hours) + ':' +
    //                 (minutes > 9 ? minutes : '0' + minutes) + ':'
    //                 + (seconds > 9 ? seconds : '0' + seconds)
    //             )
//         }
//     }

  
//     const clearTimer = (e) => {
  
  //         // If you adjust it you should also need to
  //         // adjust the Endtime formula we are about
  //         // to code next    
  //         setTimer('00:00:00');
  
//         // If you try to remove this line the 
//         // updating of timer Variable will be
//         // after 1000ms or 1sec
//         if (Ref.current) clearInterval(Ref.current);
//         const id = setInterval(() => {
//             startTimer(e);
//         }, 1000)
//         Ref.current = id;
//     }

//     const getDeadTime = () => {
  //         let deadline = new Date();
  
  //         // This is where you need to adjust if 
//         // you entend to add more time
//         deadline.setSeconds(deadline.getSeconds() + 0);
//         return deadline;
//     }

//     // We can use useEffect so that when the component
//     // mount the timer will start as soon as possible

//     // We put empty array to act as componentDid
//     // mount only
//     useEffect(() => {
  //         clearTimer(getDeadTime());
//     }, []);
  
//     // Another way to call the clearTimer() to start
//     // the countdown is via action event from the
//     // button first we create function to be called
//     // by the button
//     const onClickReset = () => {
//         clearTimer(getDeadTime());
//     }



 
//   const Ref = useRef(null);
  
//     // The state for our timer
//     const [timer, setTimer] = useState('25:00');
  
  
//     const getTimeRemaining = (e) => {
  //         const total = Date.parse(e) - Date.parse(new Date());
  //         const seconds = Math.floor((total / 1000) % 60);
  //         const minutes = Math.floor((total / 1000 / 60) % 60);
  //         return {
//             total, minutes, seconds
//         };
//     }


//     const startTimer = (e) => {
  //         let { total, minutes, seconds } 
  //                     = getTimeRemaining(e);
  //         if (total >= 0) {
    
    //             // update the timer
    //             // check if less than 10 then we need to 
    //             // add '0' at the beginning of the variable
    //             setTimer(
      //                 (minutes > 9 ? minutes : '0' + minutes) + ':'
      //                 + (seconds > 9 ? seconds : '0' + seconds)
      //             )
      //         }
      //     }
      
      
      //     const clearTimer = (e) => {
        
        //         // If you adjust it you should also need to
        //         // adjust the Endtime formula we are about
        //         // to code next    
        //         setTimer('25:00');
        
        //         // If you try to remove this line the 
        //         // updating of timer Variable will be
        //         // after 1000ms or 1sec
        //         if (Ref.current) clearInterval(Ref.current);
        //         const id = setInterval(() => {
          //             startTimer(e);
          //         }, 1000)
          //         Ref.current = id;
          //     }
          
          
          
          //     const getDeadTime = () => {
            //         let deadline = new Date();
            
            //         // This is where you need to adjust if 
            //         // you entend to add more time
            //         deadline.setSeconds(deadline.getSeconds() + 1500);
            //         return deadline;
            //     }
            
            //     // We can use useEffect so that when the component
            //     // mount the timer will start as soon as possible
            
            //     // We put empty array to act as componentDid
            //     // mount only
            //     useEffect(() => {
              //         clearTimer(getDeadTime());
              //     }, []);
              
              //     // Another way to call the clearTimer() to start
              //     // the countdown is via action event from the
              //     // button first we create function to be called
              //     // by the button
              //     const onClickReset = () => {
                //         console.log("clicked reset")
//         clearTimer(getDeadTime());
//     }

//     const onClickStart = () => {
  
//     }

//     const onClickPause = () => {
  //       console.log("clicked pause")
  //     }
  const Clock = () => {


    const [startingTime, setStartingTime] = useState(1500);
    const [stage, setStage] = useState(1);

    let { pause, running, seconds, start, stop, setSeconds} = useTimer();


   const [originalSeconds, setOriginalSeconds] = useState(0)

    const handleOptionChange = (newTime, newStage) => {
      setStartingTime(newTime);
      setSeconds(newTime * 60);
      setStage(newStage)
      setOriginalSeconds(newTime * 60)
      
    }

    
    
    
    
    
    

    
    let display

    let displayMinutes = Math.floor((seconds / 60) % 60);

    if (displayMinutes === 0 && seconds === 3600 ) {
      displayMinutes = 60;
    }

    let displaySeconds = seconds % 60;

    if (displaySeconds > 9) {

     display = displayMinutes + ':' + displaySeconds; 

    } else {
      display = displayMinutes + ':' + '0' + displaySeconds;
    }

    if (seconds === originalSeconds / stage
      || seconds === (originalSeconds / stage) * 2
      || seconds === (originalSeconds / stage) * 3
      || seconds === (originalSeconds / stage) * 4
      || seconds === (originalSeconds / stage) * 5
      ) 
      
    {
      startBell.play()
    }

    if (seconds === 0) {
      endBell.play()
      stop()
    }

  


    // const stageBells = (stages) = {
    //   if (seconds % stages == 0) {
    //     startBell.play()
    // }
  
return (
  <div className="Clock show-clock">

    

            {
                (!running) ? 
                <Options setStartingTime={handleOptionChange}></Options>
                :
                <></>
            }

      <h1 className="display-clock">{display}</h1>
      <Button className="button-clock" size="lg" variant="dark" onClick={running ? pause : start} >
           
            {
                (!running) ? 
                <BsPlayCircle />
                :
                <BsPauseCircle />
            }
        
      </Button>
      <Button className="button-clock" size="lg" variant="dark" onClick={stop}>Stop</Button>
</div>
    )
}
  
export default Clock;




// import React, { Component } from "react";
// import { CountdownCircleTimer } from "react-countdown-circle-timer";

// class Timer extends Component {
//   state = {
//     isPlaying: false,
//     durationSeconds: 31,
//     colors: [["#dadfe0", 1]]
//   };

//   startTimer = () => {
//     this.setState({
//       isPlaying: true,
//     });
//   };

  // resetTimer = () => {
  //   if (this.state.isPlaying === false) {
  //     this.setState({
  //       isPlaying: false,
  //       colors: [["#ee5253", 0.33], ["#feca57", 0.33], ["#1abc9c"]]
  //     });
  //   }
  // };

//   render() {
//     const isPlaying = this.state.isPlaying;

//     const durationSeconds = this.state.durationSeconds;

//     const colors = this.state.colors;

//     const renderTime = value => {
//       if (value === 0) {
//         return (
//           <div className="timer">
//             <button className="btn-white" onClick={this.startTimer}>
//               Restart
//             </button>
//           </div>
//         );
//       }

//       if (value === 31) {
//         return (
//           <div className="timer">
//             <button className="btn-white" onClick={this.startTimer}>
//               Start
//             </button>
//             <audio className="audio-element">
//               <source src="http://commondatastorage.googleapis.com/codeskulptor-demos/DDR_assets/Sevish_-__nbsp_.mp3" />
//             </audio>
//           </div>
//         );
//       }

//       if (value <= 30) {
//         return (
//           <div className="timer">
//             <div className="value">{value}</div>
//             <audio className="audio-element">
//               <source src="http://commondatastorage.googleapis.com/codeskulptor-demos/DDR_assets/Sevish_-__nbsp_.mp3" />
//             </audio>
//           </div>
//         );
//       }
//     };

//     return (
//       <CountdownCircleTimer
//         isPlaying={isPlaying}
//         size={240}
//         durationSeconds={durationSeconds}
//         colors={colors}
//         trailColor={"#dadfe0"}
//         strokeWidth={20}
//         renderTime={renderTime}
//         onComplete={() => [false]}
//       />
//     );
//   }
// }

// export default Timer;
